import convertWhenToPrefix from './toPrefix'
import convertWhenToInfix from './toInfix'

export const toPrefix = (formValues) => {
  const logic = formValues?.logic ? formValues?.logic : []

  return logic
    .filter((field) => field?.actions?.length > 0)
    .map((field) => ({
      ...field,
      actions: field?.actions?.map((action) => ({
        ...action,
        when: convertWhenToPrefix(action?.when),
      })),
    }))
}

export const toInfix = (formValues) => {
  const logic = formValues?.logic ? formValues?.logic : []

  return logic
    .filter((field) => field?.actions?.length > 0)
    .map((field) => ({
      ...field,
      actions: field?.actions?.map((action) => ({
        ...action,
        when: convertWhenToInfix(action?.when),
      })),
    }))
}
